export default {
  root: { width: '500px', backgroundColor: '#FFFFFF' },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
};
